import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import {
  Button,
  Hidden,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Container,
  CircularProgress,
} from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import Descarga from '@material-ui/icons/GetApp';

import api from '../../helpers/api';

const useStyles = makeStyles((theme) => ({
  imageQr: {
    width: '100%',
  },
  center: {
    textAlign: 'center',
    fontSize: 'large',
  },
  red: {
    color: '#ff2323fc',
  },
  bred: {
    background: '#ff5c5cfc',
    color: '#ffffff',
    padding: '2px 8px 2px 8px',
  },
}));

export default ({ open, setOpen, autorizacion }) => {
  const classes = useStyles();
  const { token, permisoCC } = useSelector((state) => state.auth);
  const [data, setData] = useState({});
  const [codigoQr, setCodigoQr] = useState(null);

  const handleClose = () => {
    setOpen(false);
  };

  const handleDescargaQr = async () => {
    //https://gist.github.com/javilobo8/097c30a233786be52070986d8cdb1743
    await api
      .get(`v1/autorizaciones/${autorizacion.id}/qr/download`, {
        headers: {
          Authorization: token,
        },
        responseType: 'blob', // important
      })
      .then((response) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'file.pdf');
        document.body.appendChild(link);
        link.click();
      });
  };

  const zeroPad = (num, places) => String(num).padStart(places, '0');

  useEffect(() => {
    if (open) {
      const getQR = async () => {
        const response = await api.get(`v1/autorizaciones/${autorizacion.id}/qr`, {
          headers: {
            Authorization: token,
          },
        });
        setData(response.data.data);
        setCodigoQr(response.data.codigo);
      };
      getQR();
    }
  }, [open, token, autorizacion]);

  return (
    <>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby='alert-dialog-title'
        aria-describedby='alert-dialog-description'
      >
        <DialogTitle id='alert-dialog-title'>
          {'Código QR'}
          {!permisoCC && (
            <span
              className={classes.red}
              style={{ fontSize: 'small', marginLeft: '5px' }}
            >
              (Usted no posee Certificado de Circulación)
            </span>
          )}
        </DialogTitle>
        <DialogContent>
          <Container className={classes.center}>
            {codigoQr !== null ? (
              <>
                <img src={data} className={classes.imageQr} alt='Código QR' />
                <b className={permisoCC ? null : classes.bred}>{zeroPad(codigoQr, 12)}</b>

                <Hidden only={['lg', 'xl']}>
                  <br />
                  <p style={{ fontSize: 'small' }}>( Hacé una captura de pantalla )</p>
                </Hidden>
              </>
            ) : (
              <CircularProgress color='secondary' />
            )}
          </Container>
        </DialogContent>
        <DialogActions>
          <Hidden only={['sm', 'xs', 'md']}>
            <Button onClick={handleDescargaQr} color='primary'>
              Descargar <Descarga />
            </Button>
          </Hidden>
          <Button onClick={handleClose} color='primary'>
            Cerrar
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
